<div class="head">
    <i class="search-ic icon-search search-icon"></i>
    <input type="text"
           class="ellipsis"
           autocomplete="off"
           #inputControl="ngModel"
           [(ngModel)]="lookupQuery"
           [placeholder]="placeholderText"
           [maxLength]="maxQueryLength"
           [disabled]="isDisabled"
           (ngModelChange)="onQueryChange($event)"
           (keydown.space)="onInput($event)"
           (focus)="open()">
    <!-- appRestrictSpecialSymbols -->

    <i *ngIf="showSpinner" class="spinner-ic icon-simple_refresh"></i>
    <button id="close-lookup"
            appTrackClickButton
            type="button"
            *ngIf="showClearControl"
            (click)="resetSearchResults()"
            class="clear-ic icon-cross_16px"></button>
</div>

<div *ngIf="showResults" class="suggestions">
    <cdk-virtual-scroll-viewport
        *ngIf="optionsList?.length; else noSearchResults" 
        [itemSize]="srollItemHeight" 
        calculateVirtualHeight
        [itemsQuantity]="optionsList?.length"
        [itemHeightInPx]="srollItemHeight"
        [maximumQuantityOfVisibleElements]="quantityOfVisibleItems"
        >
        <ul style="margin:0;padding:0;list-style:none;">
            <li *cdkVirtualFor="let option of optionsList">
                <button type="button" (click)="select(option)">
                    <ng-template
                        [ngTemplateOutlet]="lookupOption || defaultOptionTemplate"
                        [ngTemplateOutletContext]="{
                            option: option,
                            query: lookupQuery
                            }">
                    </ng-template>
                </button>
            </li>
        </ul>
    </cdk-virtual-scroll-viewport>
</div>

<!--no search results message-->
<ng-template #noSearchResults>
    <div class="no-results">No results found</div>
</ng-template>

<!--Default lookup option template (It will be used if template not specified outside [transclude])-->
<ng-template #defaultOptionTemplate let-option="option">
    <div class="default-option ellipsis">{{ propertyNameToDisplay ? option[this.propertyNameToDisplay] : option }}</div>
</ng-template>
